<template>
    <div v-if="count > 0" class="alert-container">
        <div class="alert-content">
            <span class="alert-icon">⚠️</span>

            <span class="alert-message">
                Hay {{ count }} envío<span v-if="count > 1">s</span> con error de sincronización con el partner
            </span>
        </div>

        <button class="alert-button" @click="handleClick">
            {{ btnText }}
        </button>
    </div>
</template>

<script>
export default {
    name: "PartnerErrorAlert",
    props: {
        count: {
            type: Number,
            required: true,
            default: 0,
        },
    },
    data() {
        return {
            applyFilter: false
        }
    },
    methods: {
        handleClick() {
            this.applyFilter = !this.applyFilter
            this.$emit("filter-errors", this.applyFilter);
        },
    },
    computed: {
        btnText() {
            return this.applyFilter ? "Ver todo los envíos" : "Ver envíos con error";
        },
    },
};
</script>

<style scoped>
.alert-container {
    margin-bottom: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff3cd;
    border: 1px solid #ffeeba;
    color: #856404;
    padding: 12px 16px;
    border-radius: 8px;
    font-family: Arial, sans-serif;
}

.alert-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

.alert-icon {
    font-size: 18px;
}

.alert-message {
    font-size: 14px;
}

.alert-button {
    background-color: #856404;
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
}

.alert-button:hover {
    background-color: #6c5203;
}
</style>